export type OrganicTabId =
  | "facebook-content"
  | "instagram-content"
  | "facebook-followers"
  | "instagram-followers";

export interface OrganicPlatformConfig {
  sourceName: string;
  tabs: OrganicTabId[];
}

export const ORGANIC_PLATFORMS: OrganicPlatformConfig[] = [
  { sourceName: "Facebook", tabs: ["facebook-content", "facebook-followers"] },
  { sourceName: "Instagram", tabs: ["instagram-content", "instagram-followers"] },
];

export const ORGANIC_TAB_ITEMS: OrganicTabId[] = ORGANIC_PLATFORMS.flatMap(
  platform => platform.tabs
);

export const getVisibleOrganicTabs = (connectedSources: readonly string[]): OrganicTabId[] =>
  ORGANIC_PLATFORMS.filter(platform => connectedSources.includes(platform.sourceName)).flatMap(
    platform => platform.tabs
  );

export const ORGANIC_TAB_I18N_KEYS: Record<OrganicTabId, string> = {
  "facebook-content": "organicMedia.tabs.facebookContent",
  "instagram-content": "organicMedia.tabs.instagramContent",
  "facebook-followers": "organicMedia.tabs.facebookFollowers",
  "instagram-followers": "organicMedia.tabs.instagramFollowers",
};
